import {baseApiUrl} from "../data/defaultConfig";
import {useBusyContext} from "../contexts/busycontext";

const DEFAULT_HEADERS = {
    'Content-Type': 'application/json;charset=utf-8',
    'X-Requested-With': 'XMLHttpRequest',

};
const MULTIPART_HEADER = {
    'X-Requested-With': 'XMLHttpRequest',
    'Accept': '*/*'
}
const HTTP_STATUS_NO_CONTENT = 204;
const HTTP_STATUS_UNAUTHORIZED = 401;
const HTTP_STATUS_FORBIDDEN = 403;

function FetchError(messageForUser) {
    const error = new Error();
    error.messageForUser = messageForUser;
    return error;
}

//addCsrf header is only necessary for POST/PUT/DELETE, not for GET
//we get the csrf-token from the cookie and add it in the X-XSRF-TOKEN header
function getHeaders(addCsrf, addExtraHeaders, isMultipart) {
    const headersWithExtra = isMultipart ? {...MULTIPART_HEADER, ...addExtraHeaders} : {...DEFAULT_HEADERS, ...addExtraHeaders};
    if (!addCsrf) return headersWithExtra;

    const cookie = document.cookie.match(new RegExp('XSRF-TOKEN=([^;]+)'));

    const csrfToken = cookie && cookie[1];

    if (!csrfToken) return headersWithExtra;

    return {...headersWithExtra, 'X-XSRF-TOKEN': csrfToken};
}

function fetchOptionMultipart(addCsrf, addExtraHeaders, isMultipart, method, bodyObject) {
    const formData = new FormData();
    formData.append("file", bodyObject.file)
    return {
        method: method,
        headers: getHeaders(addCsrf, addExtraHeaders, isMultipart),
        body: formData,
        credentials: "include"
    };
}

function fetchOptionsDefault(addCsrf, addExtraHeaders, isMultipart, method, bodyObject) {
    return {
        method: method,
        headers: getHeaders(addCsrf, addExtraHeaders, isMultipart),
        body: JSON.stringify(bodyObject),
        credentials: "include"
    };
}

async function fetchCommon(method, url, bodyObject, addCsrf, addExtraHeaders, isMultipart) {


    let result = undefined;

    let fetchOptions;
    fetchOptions = isMultipart ? fetchOptionMultipart(addCsrf, addExtraHeaders, isMultipart, method, bodyObject) : fetchOptionsDefault(addCsrf, addExtraHeaders, isMultipart, method, bodyObject);
    //exceptions will be catched by the use-mutations
    console.log(window.location.origin)
    const response = await fetch(`${window.location.origin.includes('localhost') ? window.location.origin.replace('3000', '8443') : window.location.origin + ':8443'}${url}`, fetchOptions);
    console.log(response)
    if (response.ok) {
        result = (response.status !== HTTP_STATUS_NO_CONTENT) ? await response.json() : {};
    } else {
        if (response.status === HTTP_STATUS_UNAUTHORIZED || response.status === HTTP_STATUS_FORBIDDEN) {
            throw new FetchError("not logged in.")
        } else {
            const responseBody = await response.json();
            const errorMessage = responseBody.errors &&
                responseBody.errors.reduce((accumulator, error) => `${accumulator} ${error.defaultMessage}  --- `, "--- ");
            throw new FetchError(errorMessage || responseBody.message);
        }
    }

    return result;
}

//attention: dummyData may mock the fetch
export async function fetchGET(url) {
    return await fetchCommon("GET", url, undefined);
}

export async function fetchGETWithExtraHeaders(url, addExtraHeaders) {
    return await fetchCommon("GET", url, undefined, false, addExtraHeaders);
}

export async function fetchPUT(url, bodyObject) {
    return await fetchCommon("PUT", url, bodyObject, true);
}

export async function fetchPOST(url, bodyObject, isMultipart) {
    return await fetchCommon("POST", url, bodyObject, true, false, isMultipart);
}

export async function fetchDELETE(url) {
    return await fetchCommon("DELETE", url, undefined, true);
}
